import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommonTabs, { TABS_APPEARANCE } from '../../../components/common-tabs/CommonTabs';
import PanelBody from '../../components/panel-body/PanelBody';
import TextTab from './components/text-tab/TextTab';
import FontsTab from './components/fonts-tab/FontsTab';

const TABS = [
  { id: 'text', labelKey: 'textTab', Component: TextTab },
  { id: 'fonts', labelKey: 'myFonts', Component: FontsTab },
];

function TextPanel() {
  const { t } = useTranslation('mediaStudio');
  const [tabIndex, setTabIndex] = useState(0);
  const { Component } = TABS[tabIndex];

  return (
    <PanelBody>
      <CommonTabs
        tabs={TABS.map((tab) => ({ label: t(tab.labelKey) }))}
        value={tabIndex}
        onChange={(_, index) => setTabIndex(index)}
        appearance={TABS_APPEARANCE.FILLED}
        isFullWidth
      />
      <Component />
    </PanelBody>
  );
}

export default TextPanel;
